import validationMessages from "../../../validationMessages";
import { MAX_COMPANY_NAME_LENGTH, MAX_JOB_TITLE_LENGTH } from "../../../constants";
import { RegistrationErrorMessage } from "../../../types";

export function getErrorMessageForGoogle(
    provider: string,
    errorCode: string
): RegistrationErrorMessage | undefined {
    if (provider !== "google" || !errorCode) {
        return undefined;
    }

    switch (errorCode) {
        case "invalid_product_uid":
            return { descriptor: validationMessages.invalidProductUid };
        case "user_already_exist":
            return { descriptor: validationMessages.emailRegistered };
        case "user_email_domain_in_blocked_list":
            return { descriptor: validationMessages.emailDomainInBlockedList };
        case "signup_blocked":
            return { descriptor: validationMessages.signupBlocked };
        case "invalid_account_name":
            return { descriptor: validationMessages.companyNameInvalidChars };
        case "account_name_too_long":
            return {
                descriptor: validationMessages.companyNameTooLong,
                values: { maxCompanyNameLength: MAX_COMPANY_NAME_LENGTH }
            };
        case "invalid_job_title":
            return { descriptor: validationMessages.jobTitleInvalidChars };
        case "job_title_too_long":
            return {
                descriptor: validationMessages.jobTitleTooLong,
                values: { maxJobTitleLength: MAX_JOB_TITLE_LENGTH }
            };
        default:
            return { descriptor: validationMessages.genericError };
    }
}
